import {ChangeDetectionStrategy, Component} from '@angular/core';
import {SbbDialogContent, SbbDialogTitle, SbbDialogCloseButton} from '@sbb-esta/lyne-angular/dialog';
import {QuickActionInputComponent} from '../quick-action-input/quick-action-input.component';

@Component({
  selector: 'app-quick-action-dialog',
  imports: [SbbDialogTitle, SbbDialogContent, SbbDialogCloseButton, QuickActionInputComponent],
  templateUrl: './quick-action-dialog.component.html',
  styleUrl: './quick-action-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class QuickActionDialogComponent {}
